import BaseApi from "@/services/api/BaseApi.ts";

export default class RegistrationApi extends BaseApi {
    public init() {
        return this.axios.get('/init');
    }

    public createBuyerProspect(data: any) {
        return this.axios.post('/buyer-prospects', data);
    }

    public updateBuyerProspect(reference: string, data: any) {
        return this.axios.patch(`/buyer-prospects/${reference}`, data);
    }

    public getDashboardLoginToken(userReference: string) {
        return this.axios.get(`/buyer-prospects/${userReference}/dashboard-token`);
    }

    public sendPhoneVerificationCode(reference: string) {
        return this.axios.post(`/buyer-prospects/${reference}/send-phone-verification-code`);
    }
    public verifyPhone(reference: string, code: string) {
        return this.axios.post(`/buyer-prospects/${reference}/verify-phone`, {
            code
        });
    }

    public verifyEmail(reference: string) {
        return this.axios.post(`/buyer-prospects/${reference}/verify-email`);
    }

    public getLeadPrices(reference: string) {
        return this.axios.get(`/buyer-prospects/${reference}/lead-prices`);
    }
}